/* eslint-disable prettier/prettier */
import React, { useState, useRef, useEffect } from 'react';

import moment from 'moment';

import PeriodSelect from 'components/PeriodSelect';
import Section from 'components/Section';
import CustomSelect, { RenderProps as CustomSelectRenderProps } from 'components/Selects/CustomSelect';
import SearchSelect, { RenderProps as SearchSelectRenderProps } from 'components/Selects/SearchSelct';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { CostCenter } from 'models/costCenter';
import { DefaultCostCenterId } from 'screens/components/TravelReport/TravelReportFilter/constants/cost-centers';

import { ReportFiltersContainer } from '../styles';
import OptionsItems from './components/OptionsItems';
import { Button } from './styles';
import { TravelReportObject } from 'models/allReservations';
import { AllReservationsReportProducts, AllReservationsReportRequest } from 'models/allReservationsReport';
import { Company } from 'models/company';
import { getCostCenters } from 'services/costCenterService';
import { fetchAllUsersActive } from 'actions/adminUser';
import { AdminUser } from 'models/adminUser';
import { MyThunkDispatch, RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { BreakRulesReason, getBreakRulesReasonForTravel } from 'services/travelBreakRulesReasonService';
import { Group } from 'models/group';
import { fetchGroupListServiceByCompany } from 'actions/group';
import { TravelStatus } from 'models/travelStatus';
import Input from 'components/Input';
import LoadingFilter from 'components/LoadingFilter';
import { TravelArrangerUsersAllowed, getAllowedTravelersByCompany } from 'services/userService';
// import Input from 'components/Input';

interface Props {
  loading: boolean;
  companiesList: Company[];
  costCenterList: CostCenter[];
  breakRuleReasonIdList: BreakRulesReason[],
  userGroupIdList: Group[],
  usersList: AdminUser[],
  fetchUsersAndInvites: (companyId: string) => Promise<void>;
  travelReportList: TravelReportObject[];
  fetchReportData: (filters: AllReservationsReportRequest, type: string) => Promise<any>;
  onSetPeriodText: (period?: string) => void;
  isSubmit: boolean;
}


const AllReservationsReportForm = ({ loading, companiesList, usersList, fetchUsersAndInvites, costCenterList, breakRuleReasonIdList, userGroupIdList, travelReportList, fetchReportData, onSetPeriodText, isSubmit }: Props) => {
  const { t } = useStoreTranslation();
  const isMobile = useIsMobile();
  const [userValue, setSearchUserText] = useState('');
  const [costCenterValue, setSearchText] = useState('');
  const [breakRuleReasonIdValue, setBreakRuleReasonIdValue] = useState('');
  const [userGroupIdValue, setUserGroupIdValue] = useState('');
  const [travelStatusValue, setTravelStatusValue] = useState('');
  const [travelItineraryIdValue, setTravelItineraryIdValue] = useState('');
  const [companyValue, setSearchCompanyText] = useState('');
  const [selectedProduct, setSelectedProduct] = useState<AllReservationsReportProducts>();
  const [selectedCostCenter, setSelectedCostCenter] = useState<CostCenter>();
  const [selectedBreakRuleReasonId, setSelectedBreakRuleReasonId] = useState<BreakRulesReason>();
  const [selectedUserGroupId, setSelectedUserGroupId] = useState<Group>();
  const [selectedTravelStatus, setSelectedTravelStatus] = useState<TravelStatus>();
  const [selectedCompany, setSelectedCompany] = useState<Company>();
  const [selectedUser, setSelectedUser] = useState<AdminUser>();
  const [selectedTravelReport, setSelectedTravelReport] = useState<TravelReportObject>();
  const [filterStartDate, setFilterStartDate] = useState<string>();
  const [filterEndDate, setFilterEndDate] = useState<string>();
  const [filterStartDateReservation, setFilterStartDateReservation] = useState<string>();
  const [filterEndDateReservation, setFilterEndDateReservation] = useState<string>();
  const [loadingCost, setloadingCost] = useState<boolean>(false);
  const [loadingUser, setloadingUser] = useState<boolean>(false);
  const [loadingUserGroup, setloadingUserGroup] = useState<boolean>(false);
  const productRef = useRef(null);
  const userRef = useRef(null);
  const companyRef = useRef(null);
  const costCenterRef = useRef(null);
  const breakRuleReasonIdRef = useRef(null);
  const userGroupIdRef = useRef(null);
  const travelStatusRef = useRef(null);

  const productList = [
    { label: t('allReservationsReport.report.filterForm.products.all'), value: AllReservationsReportProducts.All },
    { label: t('allReservationsReport.report.filterForm.products.flight'), value: AllReservationsReportProducts.Air },
    { label: t('allReservationsReport.report.filterForm.products.vehicle'), value: AllReservationsReportProducts.Vehicle },
    { label: t('allReservationsReport.report.filterForm.products.hotel'), value: AllReservationsReportProducts.Hotel },
  ];

  const travelStatusList = [
    { key: t('allReservationsReport.report.status.All'), value: '' },
    { key: t('allReservationsReport.report.status.PreApproved'), value: 'PreApproved' },
    { key: t('allReservationsReport.report.status.Confirmed'), value: 'Confirmed' },
    { key: t('allReservationsReport.report.status.ErrorAtSending'), value: 'ErrorAtSending' },
    { key: t('allReservationsReport.report.status.Expired'), value: 'Expired' },
    { key: t('allReservationsReport.report.status.Pending'), value: 'Pending' },
    { key: t('allReservationsReport.report.status.Approved'), value: 'Approved' },
    { key: t('allReservationsReport.report.status.Reproved'), value: 'Reproved' },
    { key: t('allReservationsReport.report.status.Cancelled'), value: 'Cancelled' },
    { key: t('allReservationsReport.report.status.PaymentFailure'), value: 'PaymentFailure' },
    { key: t('allReservationsReport.report.status.Paid'), value: 'Paid' }
  ];

  const travelStatusOptions = Object.keys(TravelStatus)
  .filter(key => isNaN(Number(key)))
  .map(key => ({
    key,
    value: TravelStatus[key as keyof typeof TravelStatus]
  }));

  travelStatusOptions.find(someobject => someobject.key.toUpperCase() === 'EMPTY').key = 'Todos';


  const [companies, setCompanies] = useState(companiesList);
  const [users, setUsers] = useState([]);
  const [costCenters, setCostCenters] = useState(costCenterList);
  const [breakRuleReasonIds, setBreakRuleReasonIds] = useState(breakRuleReasonIdList);
  const [userGroupIds, setUserGroupIds] = useState(userGroupIdList);
  const [travelStatuss, setTravelStatuss] = useState(travelStatusOptions);
  const [travelReports, setTravelReports] = useState(travelReportList);
  const [labelReport, setLabelReport] = useState('');
  const [labelReportReservation, setLabelReportReservation] = useState('');
    const [selectedProductText, setProductLabel] = useState('');
  const [selectedCompanyText, setCompanyLabel] = useState('');
  const handleFetchUsersAndInvites = (companyId: string) => dispatch(fetchAllUsersActive(companyId));
  const dispatch: MyThunkDispatch = useDispatch();
  const userData = useSelector((state: RootState) => state.user.accountResult);

  const handleSelectProduct = (name: string) => {
    const product = productList.find((g) => g.value === name);
    setProductLabel(product?.label ?? '');
    setSelectedProduct(product?.value as AllReservationsReportProducts);
  };

  const handleChangeCostCenter = (e: React.FormEvent<HTMLInputElement>) => {
    const inputedValue = e.currentTarget.value;
    setSearchText(inputedValue);

    if (!inputedValue) {
      setCostCenters(costCenterList);
      setSelectedCostCenter(undefined);
    } else {
      setCostCenters(costCenterList.filter((c) => c.name?.toLowerCase().includes(inputedValue.toLowerCase()) || c.code?.toLowerCase().includes(inputedValue.toLowerCase())));
    }
  };

  const handleBreakRuleReasonId = (e: React.FormEvent<HTMLInputElement>) => {
    const inputedValue = e.currentTarget.value;
    setBreakRuleReasonIdValue(inputedValue);

    if (!inputedValue) {
      setBreakRuleReasonIds(breakRuleReasonIdList);
      setSelectedBreakRuleReasonId(undefined);
    } else {
      setBreakRuleReasonIds(breakRuleReasonIdList.filter((c) => c.name?.toLowerCase().includes(inputedValue.toLowerCase()) || c.id?.toLowerCase().includes(inputedValue.toLowerCase())));
    }
  };

  const handleChangeUserGroupId = (e: React.FormEvent<HTMLInputElement>) => {
    const inputedValue = e.currentTarget.value;
    setUserGroupIdValue(inputedValue);

    if (!inputedValue) {
      setUserGroupIds(userGroupIdList);
      setSelectedUserGroupId(undefined);
    } else {
      setUserGroupIds(userGroupIdList.filter((c) => c.name?.toLowerCase().includes(inputedValue.toLowerCase()) || c.id?.toLowerCase().includes(inputedValue.toLowerCase())));
    }
  };

  const handleChangeTravelStatus = (name: string) => {
    //const travel = travelStatusOptions.find((g) => g.value === value);
    const travel = travelStatusList.find((g) => g.key === name);
    setTravelStatusValue(travel?.key ?? '');
    setSelectedTravelStatus(travel?.value as TravelStatus);
  };

  const handleChangeTravelItineraryId = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // Aquí puedes acceder a event.target.value para obtener el valor del input
    const newValue = event.target.value;
    setTravelItineraryIdValue(newValue)
    // Haz algo con newValue
  };

  const handleChangeUser = (e: React.FormEvent<HTMLInputElement>) => {
    
    const inputedValue = e.currentTarget.value;
    setSearchUserText(inputedValue);
    if (!inputedValue) {
      setUsers(users);      
    } else {
        setUsers(users.filter((c) => c.name?.toLowerCase().includes(inputedValue.toLowerCase())));
    }
  };

  const handleChangeCompany = (e: React.FormEvent<HTMLInputElement>) => {
    const inputedValue = e.currentTarget.value;
    setSearchCompanyText(inputedValue);

    if (!inputedValue) {
      setCompanies(companiesList);
      setSelectedCompany(undefined);
    } else {
      setCompanies(companiesList.filter((c) => c.companyName?.toLowerCase().includes(inputedValue.toLowerCase())));
    }
  };

  const handleSelectCostCenter = (id: string) => {
    const costCenter = costCenters.find((costCenter) => costCenter.id === id);
    setSearchText(costCenter?.name ?? costCenter?.code ?? '');
    setSelectedCostCenter(costCenter);
  };

  const handleSelectBreakRulesReasonId = (id: string) => {
    const breakRulesReasonId = breakRuleReasonIds.find((breakRulesReasonId) => breakRulesReasonId.id === id);
    setBreakRuleReasonIdValue(breakRulesReasonId?.name ?? breakRulesReasonId?.id ?? '');
    setSelectedBreakRuleReasonId(breakRulesReasonId);
  };

  const handleSelectUserGroupId = (id: string) => {

    const userGroupId = userGroupIds.find((userGroupId) => userGroupId.id === id);

    setUserGroupIdValue(userGroupId?.name ?? '');
    setSelectedUserGroupId(userGroupId);
  };

  const cleanForm = () => {
    setSearchText('');
    setSelectedCostCenter(undefined);
    setProductLabel('');
    setSelectedProduct(undefined);
    setBreakRuleReasonIdValue('');
    setUserGroupIdValue('');
    setSelectedUserGroupId(undefined);
    setSearchUserText('');
    setTravelStatusValue('');
    setTravelItineraryIdValue('');
    //setResetDateReservation('resetValue');
    /*setFilterStartDate('');
    setFilterEndDate('');
    setFilterStartDateReservation('');
    setFilterEndDateReservation('');*/
  }

  const handleSelectCompany = (id: string) => {
    const company = companies.find((c) => c.id === id);
    setSearchCompanyText(company?.companyName);
    setSelectedCompany(company);
    getCostCenterByCompanyId(company?.id);
    getBreakRulesReasonByCompanyId(company?.id)
    getAllUsersByCompanyId(company?.id);
    getAllUserGroups(company?.id);
    cleanForm();
    setloadingCost(true);
    setloadingUser(true);
    setloadingUserGroup(true);
    //changeDateFilters('', '', 'current', 'datesReservation');
    //changeDateFilters('', '', 'current', 'createdDates');
  };

  const handleSelectUser = (id: string) => {
    const user = users.find((c) => c.id === id);
    setSearchUserText(user?.name ?? user?.lastName ?? '');
    setSelectedUser(user);
  };

  const getCostCenterByCompanyId = async (id: string) => {
    const res = await getCostCenters(id);
    res.data.result.unshift({
        id: '00000000-0000-0000-0000-000000000000',
        code: '',
        name: t('costCenter.report.filterForm.products.all'),
    } as CostCenter);
    setCostCenters(res.data.result);
    setloadingCost(false)
  };

  const getBreakRulesReasonByCompanyId = async (id: string) => {
    const res = await getBreakRulesReasonForTravel();
    setBreakRuleReasonIds(res.data);
  };

  const getAllUserGroups = async (id: string) => {
    const res = await fetchGroupListServiceByCompany(id);
    res.data.data.unshift({
      id: '00000000-0000-0000-0000-000000000000',
      name: t('costCenter.report.filterForm.products.all')
  } as Group);
    setUserGroupIds(res.data.data);
    setloadingUserGroup(false)
  };

  const getAllUsersByCompanyId = async (companyId: string) => {
    const res = await getAllowedTravelersByCompany(companyId);
    res.data.unshift({
      id: '00000000-0000-0000-0000-000000000000',
      name: t('costCenter.report.filterForm.products.all'),
      lastName: ''
  } as TravelArrangerUsersAllowed);
    setUsers(res.data)
    setloadingUser(false)
  };

  const onSeeResults = (type: string) => {
    console.log(selectedProduct, labelReport)
    let travelType = '';

    if (selectedProduct) {
      switch (selectedProduct) {
        case 'Air': travelType = 'Flight'; break;
        default: travelType = selectedProduct; break;
      }
    }

    const data: AllReservationsReportRequest = {
      travelItineraryId: travelItineraryIdValue ?? '',
      pageNumber: 1,
      pageSize: 1000,
      companyIdReport: selectedCompany.id ?? '',
      costCenterId: selectedCostCenter
        ? selectedCostCenter.id ?? DefaultCostCenterId
        : DefaultCostCenterId,
      reservationStartDate: filterStartDateReservation ?? '',
      reservationEndDate: filterEndDateReservation,
      travelStatus : selectedTravelStatus ?? '',
      userGroupId : selectedUserGroupId?.id ?? '',
      breakRuleReasonId: selectedBreakRuleReasonId?.id ?? '',
      userId : selectedUser?.id ?? '',
      //rejectedReasonId : selectedReje?.id ?? '',
      reservationCreatedStartDate : filterStartDate ?? '',
      reservationCreatedEndDate : filterEndDate ?? '',
      travelType : travelType
    };

    onSetPeriodText(labelReport);

    fetchReportData(data, type);
  };

  const isValidCostCenter = () => {
    if (costCenterValue || selectedCostCenter) {
      const condition = costCenterValue.toLowerCase() === selectedCostCenter?.name?.toLowerCase();
      if (!condition) return t('allReservationsReport.report.filterForm.costCenterInvalid');
    }
  };

  const isValidGroup = () => {
    if (userGroupIdValue || selectedUserGroupId) {
      const condition = userGroupIdValue.toLowerCase() === selectedUserGroupId?.name?.toLowerCase();

      if (!condition) return t('allReservationsReport.report.filterForm.userGroupInvalid');
    }
  };

  const isValidCompany = () => {
    if (companyValue || selectedCompany) {
      const condition = companyValue.toLowerCase() === selectedCompany?.companyName?.toLowerCase();

      if (!condition) return t('allReservationsReport.report.filterForm.companyInvalid');
    }
  };

  const isValidUser = () => {
    if (userValue || selectedUser) {
      const condition = userValue.toLowerCase() === selectedUser?.name?.toLowerCase();

      if (!condition) return t('allReservationsReport.report.filterForm.companyInvalid');
    }
  };

  const changeDateFilters = (start: string, end: string, value: string, name: string) => {
    let label = '';
    if (value === 'date') {
      label = `${moment(start).format('DD MMM')} - ${moment(end).format('DD MMM')}`;
    }
    if (value === 'thirtyDays') {
      label = t('periodSelect.options.lastDays');
    }
    if (value === 'previous') {
      label = t('periodSelect.options.previousMonth', {
        month: moment().subtract(1, 'months').endOf('month').format('MMMM'),
      });
    }
    if (value === 'current') {
      label = t('periodSelect.options.currentMonth', { month: moment().format('MMMM') });
    }

    if(name === 'datesReservation'){
      setFilterEndDateReservation(end);
      setFilterStartDateReservation(start);
      setLabelReportReservation(label);
      return
    }
    else if (name === 'createdDates')
    {
      setFilterEndDate(end);
      setFilterStartDate(start);
      setLabelReport(label);
    }
  };

  useEffect(() => {
    if(userData?.type === 'admin'){
      const companyAdmin = companiesList?.find(item => item.id === userData.companyId)
      return setCompanies([companyAdmin])
    }
    setCompanies(companiesList)
  }, [companiesList, userData])

  return (
    <ReportFiltersContainer>
      <Section title={t('allReservationsReport.report.filterForm.title')} joinContent={false}>
        {companies ?
          <SearchSelect
            name="company"
            error={isValidCompany()}
            onChange={handleChangeCompany}
            onChildrenChange={handleSelectCompany}
            label={t('allReservationsReport.report.filterForm.selectCompany')}
            placeHolder={t('allReservationsReport.report.filterForm.selectCompanyPlaceholder')}
            selectRef={companyRef}
            value={companyValue}
          >
            {({ ...selectProps }: CustomSelectRenderProps) => (
              <OptionsItems {...selectProps} selectRef={companyRef} companies={companies} />
            )}
          </SearchSelect>:
          <LoadingFilter></LoadingFilter>
        }
        <PeriodSelect 
          label={t('allReservationsReport.report.filterForm.selectPeriod')} 
          name='period' 
          className='createdDates' 
          handleChangeDate={changeDateFilters} />
        {/*<PeriodSelect label={t('allReservationsReport.report.filterForm.selectPeriodReservation')} name='periodReservation' className='datesReservation' handleChangeDate={changeDateFilters} />*/}
        <CustomSelect
          name="product"
          onChange={handleSelectProduct}
          label={t('allReservationsReport.report.filterForm.selectProduct')}
          placeHolder={t('allReservationsReport.report.filterForm.selectProductPlaceholder')}
          selectRef={productRef}
          value={selectedProductText}
        >
          {({ ...selectProps }: CustomSelectRenderProps) => (
            <OptionsItems {...selectProps} selectRef={productRef} products={productList} />
          )}
        </CustomSelect>
        <SearchSelect
          name="costCenter"
          error={isValidCostCenter()}
          onChange={handleChangeCostCenter}
          onChildrenChange={handleSelectCostCenter}
          label={t('allReservationsReport.report.filterForm.selectCostCenter')}
          placeHolder={t('allReservationsReport.report.filterForm.selectCostCenterPlaceholder')}
          selectRef={costCenterRef}
          value={costCenterValue}
          loading={loadingCost}
        >
          {({ ...selectProps }: SearchSelectRenderProps) => (
            <OptionsItems {...selectProps} selectRef={costCenterRef} costCenters={costCenters} />
          )}
        </SearchSelect>
        {/* <SearchSelect
          name="breakRuleReasonId"
          // error={isValidCostCenter()}
          onChange={handleBreakRuleReasonId}
          onChildrenChange={handleSelectBreakRulesReasonId}
          label={t('allReservationsReport.report.filterForm.selectBreakRuleReasonId')}
          placeHolder={t('allReservationsReport.report.filterForm.selectBreakRuleReasonIdPlaceholder')}
          selectRef={breakRuleReasonIdRef}
          value={breakRuleReasonIdValue}
        >
          {({ ...selectProps }: SearchSelectRenderProps) => (
            <OptionsItems {...selectProps} selectRef={breakRuleReasonIdRef} breakRuleReasonId={breakRuleReasonIds} />
          )}
        </SearchSelect> */}
        <SearchSelect
          name="userGroupId "
          error={isValidGroup()}
          onChange={handleChangeUserGroupId}
          onChildrenChange={handleSelectUserGroupId}
          label={t('allReservationsReport.report.filterForm.selectUserGroupId')}
          placeHolder={t('allReservationsReport.report.filterForm.selectUserGroupIdPlaceholder')}
          selectRef={userGroupIdRef}
          value={userGroupIdValue}
          loading={loadingUserGroup}
        >
          {({ ...selectProps }: SearchSelectRenderProps) => (
            <OptionsItems {...selectProps} selectRef={userGroupIdRef} userGroupId={userGroupIds} />
          )}
        </SearchSelect>
        <SearchSelect
          name="user"
          // error={isValidUser()}
          onChange={handleChangeUser}
          onChildrenChange={handleSelectUser}
          label={t('allReservationsReport.report.filterForm.selectUser')}
          placeHolder={t('allReservationsReport.report.filterForm.selectUserPlaceholder')}
          selectRef={userRef}
          value={userValue}
          loading={loadingUser}
        >
          {({ ...selectProps }: SearchSelectRenderProps) => (
            <OptionsItems {...selectProps} selectRef={userRef} users={users} />
          )}
        </SearchSelect>
        <CustomSelect
          name="travelStatus"
          // error={isValidUser()}
          onChange={handleChangeTravelStatus}
          label={t('allReservationsReport.report.filterForm.selectTravelStatus')}
          placeHolder={t('allReservationsReport.report.filterForm.selectTravelStatusPlaceholder')}
          selectRef={travelStatusRef}
          value={travelStatusValue}
        >
          {({ ...selectProps }: CustomSelectRenderProps) => (
            <OptionsItems {...selectProps} selectRef={travelStatusRef} travelStatus={travelStatusList} />
          )}
        </CustomSelect>
        {/* <Field name="countryCurrency" label="Moneda del Flujo de Reserva">
        </Field> */}
        <div>
          <label>{t('allReservationsReport.report.filterForm.inputTravelItineraryId')} </label>
          <Input onChange={handleChangeTravelItineraryId} value={travelItineraryIdValue} placeholder={t('allReservationsReport.report.filterForm.inputTravelItineraryIdPlaceholder')} />
        </div>
      </Section>
      <Section>
        <Button
          disabled={isSubmit || !selectedCompany}
          onClick={() => {
            onSeeResults('email');
          }}
          value={t('allReservationsReport.report.filterForm.sendToEmail')}
          loading={isSubmit}
        />
        <Button
          disabled={isSubmit || !selectedCompany}
          onClick={() => {
            onSeeResults('download');
          }}
          value={t('allReservationsReport.report.filterForm.download')}
          loading={isSubmit}
        />
        {!isMobile && (
          <Button
            disabled={isSubmit || !selectedCompany}
            onClick={() => {
              onSeeResults('screen');
            }}
            value={t('allReservationsReport.report.filterForm.search')}
            loading={isSubmit}
          />
        )}
      </Section>
    </ReportFiltersContainer>
  );
};

export default AllReservationsReportForm;
